function FullCalendarCarveOutSchedule(aStart, aEnd, aScheduleType, aReocurring, aSelectionId, aSelectionText, droppedSched, aZoneScheduleType, TravelFlag) {
    "use strict";
    var lStartClone = aStart.clone(),
        lEndTimeClone = aEnd.clone();

    if(droppedSched){
        lStartClone = lStartClone.add(getOffsetOfSaveDate(lStartClone.toDate()), 'minutes'),
        lEndTimeClone = lEndTimeClone.add(getOffsetOfSaveDate(lEndTimeClone.toDate()), 'minutes');
    }

    this.start = lStartClone._d;
    this.end = lEndTimeClone._d;
    this.color = getScheduleColor({ IsRecurring: aReocurring, TargetTypeId: aScheduleType, EntityId: aSelectionId, ZoneScheduleType: aZoneScheduleType, TravelFlag: TravelFlag});
    this.textColor = "#000";
    this.ScheduleType = aScheduleType;
    this.Id = Math.random();
    this.durationEditable = false;
    this.reocurring = aReocurring;
    this.editable = true;
    this.durationEditable = true;
    this.data = [];
    if (TravelFlag) {
        this.title = aSelectionText
    } else {
        this.title = aSelectionText ? CarveOutScheduleTitle(aStart, aEnd, aScheduleType, aReocurring, aSelectionText) : '';
    }
    this.parentEntity = aSelectionText;
    this.UpdatedScheduleLocal = "";
    this.edited = false;
}
if (typeof exports !== 'undefined') {
    module.exports = FullCalendarCarveOutSchedule;
}